import Connection from '../connection';

export default class DeviceService {
  constructor(inviteId) {
    this.basePath = inviteId ? `/invites/${inviteId}/devices` : '/devices';
  }

  loadDevices(userId) {
    return Connection.send(this.basePath, { userId });
  }

  requestPairCode() {
    const URL = '/requestPairCode';
    return Connection.send(`${this.basePath}${URL}`);
  }

  pairDevice(pairCode, deviceName) {
    const URL = '/pair';
    return Connection.send(`${this.basePath}${URL}`, { pairCode, deviceName }, 'POST');
  }

  checkPairStatus(deviceId, userId) {
    const URL = '/pairStatus';
    return Connection.send(`${this.basePath}${URL}`, { deviceId, userId });
  }

  unpairDevice(deviceId, userId) {
    return Connection.send(`${this.basePath}/${deviceId}`, { userId }, 'DELETE');
  }
}



// WEBPACK FOOTER //
// ./src/services/api/device_service.js